import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const InfoCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7.313a.939.939 0 1 1-.001 1.877.939.939 0 0 1 0-1.877M13.5 16.5h-3v-.75c.363-.134.75-.15.75-.551v-3.35c0-.4-.387-.464-.75-.598v-.75h2.25V15.2c0 .401.388.418.75.551z"
      clipRule="evenodd"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(InfoCircle) as SvgIcon;
export { ForwardRef as ReactComponent };
